import React from 'react';

/** Bottom-centre dark card, positioned like Collab Club's floating bar (`selected-artists-float`). */
export function Toast({ message }: { message: string }) {
  if (!message) return null;
  return (
    <div className="fixed bottom-5 left-1/2 z-[60] max-w-[calc(100vw-32px)] -translate-x-1/2 transform whitespace-nowrap rounded-lg bg-[#141414] px-4 py-3 text-base text-white shadow-lg box-border">
      {message}
    </div>
  );
}
